import React, { useState } from 'react';
import QuestionHtmlWithZoom from '../components/QuestionHtmlWithZoom';

export default function TestImageZoom() {
  const [widths, setWidths] = useState<number[]>([50, 75]);

  // 模拟包含多张图片的题干HTML
  const testHtml = `
    <p>这是一道测试题，请观察下面的图片：</p>
    <img src="https://picsum.photos/400/300?random=1" alt="测试图片1" />
    <p>这是第二张图片：</p>
    <img src="https://picsum.photos/400/300?random=2" alt="测试图片2" />
    <p>请根据图片内容回答问题。</p>
  `;

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-6 text-gray-900">题干图片缩放功能测试</h1>
        
        {/* 测试区域1：带缩放功能的 QuestionHtmlWithZoom */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-lg font-semibold mb-4 text-blue-600">测试1：带实时缩放的题干图片</h2>
          <div className="prose prose-sm max-w-none">
            <QuestionHtmlWithZoom
              html={testHtml}
              imageWidths={widths}
              onWidthChange={(newWidths) => {
                setWidths(newWidths);
              }}
            />
          </div>
          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-700">
              <strong>当前宽度值：</strong>{widths.join(', ')}%
            </p>
            <p className="text-xs text-blue-600 mt-1">
              提示：拖动滑块或输入数值来调整图片大小
            </p>
          </div>
        </div>

        {/* 测试区域2：纯预览模式（无缩放条） */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-lg font-semibold mb-4 text-green-600">测试2：纯预览模式（无缩放条）</h2>
          <div className="prose prose-sm max-w-none">
            <QuestionHtmlWithZoom
              html={testHtml}
              imageWidths={[60, 80]}
            />
          </div>
        </div>

        {/* 测试区域3：单行布局 */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-semibold mb-4 text-purple-600">测试3：单行布局（所有图片一行显示）</h2>
          <div className="prose prose-sm max-w-none">
            <QuestionHtmlWithZoom
              html={testHtml}
              imageWidths={widths}
              onWidthChange={setWidths}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
